import Prescription from '../containers/prescription/Prescription';
import PrescriptionEmission from '../containers/prescription/PrescriptionEmission/PrescriptionEmission';

const routes = [
  {
    path: '/v3/prescription/:prescriptionReference/lme',
    component: import('../containers/LME/LME'),
    isLazy: true,
  },
  {
    path: '/v3/prescription/:prescriptionReference/apac-bpa',
    component: import('../containers/apac-bpa/ApacBpa'),
    isLazy: true,
  },
  {
    path: '/v3/prescription/:prescriptionReference/safeid-configure',
    component: import('../containers/certificate/SafewebConfiguration'),
    isLazy: true,
  },
  {
    path: '/v3/prescription/:prescriptionReference/vidaas-authorize',
    component: import('../containers/certificate/VidaasAuthorize'),
    isLazy: true,
  },
  {
    path: '/v3/prescription/:prescriptionReference/safeid-authorize',
    component: import('../containers/certificate/SafewebAuthorize'),
    isLazy: true,
  },
  {
    path: '/v3/prescription/:prescriptionReference/emission',
    component: PrescriptionEmission,
  },
  {
    path: '/v3/prescription/:prescriptionReference',
    component: Prescription,
  },
];

export default routes;
